import { observer, pr, React, theme, ui } from "aaa";
import * as _ from "lodash";
import { pushRoute } from "stores/RouterFunctions";
import { BackButton } from "../util/BackButton";
import { A11yRefocus } from "./A11yRefocus";
import { NativeLinearProgress } from "./NativeLinearProgress";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

/**
 * Renders a navigation bar optionally.
 * Needs the following props
 *  - array of pages
 *  - current path
 */
@observer
export class NavigationBar extends React.Component<{
    basePath: string,
    pages: Array<{
        path: string,
        title: string,
        hideBack?: boolean,
        hideBorder?: boolean
    }>,
    path: string,
    matchBasePath?: boolean, // If true then the basePath will be matched as the first page
    backToBase?: boolean, // If true add a back button to return to base path
    hideProgress?: boolean,
    style?: React.CSSProperties
}, {}> {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const pathComponents = this.props.path.split("/");
        const pagePath = pathComponents[pathComponents.length - 1];

        let pageIndex = _.findIndex(this.props.pages, entry => entry.path === pagePath);

        if (this.props.matchBasePath && this.props.basePath === this.props.path) {
            pageIndex = 0;
        }

        if (pageIndex < 0) {
            return null;
        }

        const page = this.props.pages[pageIndex];

        const title = this.props.pages.length > 1 ?
            `${ui.__("navbar.step")} ${pageIndex + 1} - ${page.title}` : // multiple pages, show "Step 1 -" prefix
            page.title; // only one page, just show title

        const border = (!page.hideBorder && !ui.isDarkMode) ? {
            borderBottom: "solid",
            borderBottomColor: "#eee",
            borderBottomWidth: 1,

            // borderLeft: "solid",
            // borderLeftColor: "#eee",
            // borderLeftWidth: 1,

            // borderRight: "solid",
            // borderRightColor: "#eee",
            // borderRightWidth: 1
        } : {};

        const hasBackButton = (pageIndex > 0 && !page.hideBack) ||
            (pageIndex === 0 && this.props.backToBase === true);

        const isWeb = externalInterfaceStore.isGeorgeWeb;

        return (
            <pr.A11yPopupHider>
                <div
                    className="theme-background-color"
                    style={{
                        position: "fixed",
                        top: isWeb ? theme.WEB_HEADER_HEIGHT : 0,
                        width: "100%",
                        maxWidth: theme.MAX_APP_WIDTH,
                        marginLeft: "auto",
                        marginRight: "auto",
                        height: theme.NAVBAR_HEIGHT,

                        ...border,

                        zIndex: 30,
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        ...this.props.style

                    }}
                >
                    {
                        // Back to previous page
                        pageIndex > 0 && !page.hideBack &&
                        <A11yRefocus
                            focusId={pageIndex} // key to force focus
                        >
                            <BackButton
                                iconClassName="theme-navbar-back-color"
                                size={30}
                                offset={{ x: 0, y: 3 }}
                                onClick={() => pushRoute(`${this.props.basePath}/` + this.props.pages[pageIndex - 1].path)}
                            />
                        </A11yRefocus>
                    }

                    {// Back to base page
                        pageIndex === 0 && this.props.backToBase === true &&
                        <A11yRefocus
                            focusId={pageIndex}
                        >
                            <BackButton
                                iconClassName="theme-navbar-back-color"
                                size={30}
                                offset={{ x: 0, y: 3 }}
                                onClick={() => pushRoute(this.props.basePath)}
                            />
                        </A11yRefocus>
                    }

                    <pr.H1WithFocus
                        key={title} // Have to change key, otherwise iOS screen readers reads the cached first page header
                        className="theme-navbar-title-color"
                        style={{
                            margin: 0,
                            fontSize: 14,
                            fontFamily: "Inter Light"
                        }}
                        skipFocus={hasBackButton}
                    >
                        {title}
                    </pr.H1WithFocus>

                    {this.props.hideProgress !== true &&
                        <NativeLinearProgress
                            style={{ margin: "10px auto 0 auto", width: "70%", background: theme.customColors.silver }}
                            value={100 * (pageIndex + 1) / this.props.pages.length}
                        />
                    }
                </div>
                <div className="theme-background-color" style={{ height: theme.NAVBAR_HEIGHT }} />
            </pr.A11yPopupHider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/NavigationBar.tsx